export default "__VITE_ASSET__3e13a2a7__"